

var _logger = require('xo-beaver/dist/logger');

var DECLINE_TYPE = {
    PRE_AUTH: 'PREAUTH'
};

/**
 * $SharedUtil is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SharedUtil', function () {

    /**
     * checks at least one FI in the plan has cpa information
     * might not be required just having for now
     */
    var isAuthRequiredInAnyFI = function isAuthRequiredInAnyFI(checkoutSession) {
        var isAuthRequired = false;
        var plans = checkoutSession && checkoutSession.getPlanList();

        // Check if any existing plans has pre auth data.
        if (plans && plans.length) {
            isAuthRequired = plans.some(function (plan) {
                return plan.primaryFs && plan.primaryFs.pre_authorization_instruction;
            });
        }

        _logger.$logger.info('is_auth_required_fi', {
            isAuthRequired: isAuthRequired
        });

        return isAuthRequired;
    };

    var isSelectedPlanRequiresAuth = function isSelectedPlanRequiresAuth(plan) {
        var isPlanRequireAuth = plan && plan.primaryFs && plan.primaryFs.pre_authorization_instruction;

        _logger.$logger.info('is_plan_require_auth', {
            isPlanRequireAuth: isPlanRequireAuth
        });

        return isPlanRequireAuth;
    };

    /*
     * check the declined instrument is for reason auth decline
     */
    var isAuthDeclinedInstrument = function isAuthDeclinedInstrument(checkoutSession) {
        var isDeclinedInstrument = false;

        var declinedInstruments = checkoutSession.declinedInstruments || [];

        // if yes, then we make elmo call, otherwise not.
        if (declinedInstruments && declinedInstruments.length) {
            isDeclinedInstrument = declinedInstruments.some(function (instrument) {
                return instrument.decline_type === DECLINE_TYPE.PRE_AUTH;
            });
        }

        _logger.$logger.info('is_auth_declined_instrument', {
            isDeclinedInstrument: isDeclinedInstrument
        });

        return isDeclinedInstrument;
    };

    var isBoolean = function isBoolean(value) {
        return Object.prototype.toString.call(value) === '[object Boolean]';
    };

    return {
        isAuthRequiredInAnyFI: isAuthRequiredInAnyFI,
        isSelectedPlanRequiresAuth: isSelectedPlanRequiresAuth,
        isAuthDeclinedInstrument: isAuthDeclinedInstrument,
        isBoolean: isBoolean
    };
});

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/services/shared-util/index.js
// module id = ./pages/services/shared-util/index.js
// module chunks = 0